// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import ExamUploadIcon from '../../../assets/images/exam-upload-icon.svg';
import CrossIcon from '../../../assets/images/cross.svg';

const S = {
  UploadContainer: styled.div`
    margin: 30px 2% 50px;
    display: flex;
    align-items: flex-end;
  `,
  UploadIcon: styled.img.attrs({ src: ExamUploadIcon })`
    vertical-align: sub;
    padding-right: 8px;
  `,
  PreviewImg: styled.img`
    max-width: 100px;
    max-height: 100px;
    padding-left: 5px;
  `,
  UploadBtn: styled.label`
    border: 1px solid #666666;
    padding: 5px 10px;
    border-radius: 7px;
    color: #666666;
    cursor: pointer;
    margin-right: 8px;
  `,
  UploadInput: styled.input`
    display: none;
  `,
  UploadFileName: styled.p`
    margin-right: 8px;
  `,
  FileOverSize: styled.p`
    font-size: 14px;
    margin-top: 10px;
    margin-left: 2%;
    color: #FE4747;
  `,
  ClearUploadIcon: styled.img.attrs({ src: CrossIcon })`
    margin-right: 8px;
    display: block;
    width: 20px;
    border: 1px solid;
    border-radius: 50px;
    padding: 3px;
    cursor: pointer;
  `,
}

const FileUpload = (props: any): JSX.Element => {
  const handleUpload = props.handleUpload;
  const uploadFile = props.uploadFile;
  const imgAcceptList = ['image/png', 'image/jpg', 'image/jpeg', 'image/svg+xml'];
  const [fileName, setFileName] = useState('');
  const [fileSrc, setFileSrc] = useState<string>('');
  const [fileSize, setFileSize] = useState<string>('');
  const [fileOverSize, setFileOverSize] = useState(false);

  const previewImg = (files: any) => {
    // console.log(files)
    if (files.type || files.name) {
      const size = files.size;

      if (size > 1024*1024*6) {
        setFileOverSize(true);
        handleUpload('', '');
      } else {
        setFileOverSize(false);
        if (size < 1024*1024) {
          setFileSize((size/1024).toFixed(1).toString() + 'KB');
        } else {
          setFileSize(((size/1024)/1024).toFixed(1).toString() + 'MB');
        }
        setFileName(files.name);
        const reader = new FileReader();
        reader.onload = function () {
          const src = reader.result;
          if (src) {
            if (imgAcceptList.includes(files.type)) {
              setFileSrc(src as string);
            } else {
              setFileSrc('');
            }
            const params = {
              img: src as string,
              fileName: files.name,
              fileType: files.type
            };
            upload(files, JSON.stringify(params));
            return src as string
          }
        };
        reader?.readAsDataURL(files);
      }
    } else {
      setFileSrc('');
    }
  }

  const handleInput = async (e: any) => {
    if (e.target.files.length !== 0) {
      previewImg(e.target.files[0]);
    }
  }

  const upload = (file: any, base64Data: any) => {
    handleUpload(file, base64Data);
  }

  const handleClearFile = () => {
    handleUpload('', '');
  }

  useEffect(() => {
    if (uploadFile) {
      previewImg(uploadFile);
    } else {
      setFileSrc('');
      setFileName('');
      setFileSize('');
    }
  }, [uploadFile])

  return (
    <S.UploadContainer>
      <S.UploadBtn>
        <S.UploadIcon/>
        <FormattedMessage id="K019" />
        <S.UploadInput
          key={Date.now()}
          type={'file'}
          onChange={(e) => { handleInput(e) }}
        />
      </S.UploadBtn>
      { fileName ? <S.ClearUploadIcon onClick={() => { handleClearFile() }}/> : null }
      <S.UploadFileName>{ fileName }</S.UploadFileName>
      { fileSize }
      <S.PreviewImg src={fileSrc} />
      { fileOverSize ? <S.FileOverSize><FormattedMessage id={'K043'}/></S.FileOverSize> : null}
    </S.UploadContainer>
  )
}

export default FileUpload;
